export const CONVERSATIONS_CHANGED_EVENT = 'CONVERSATIONS_CHANGED';
export const CONVERSATION_STATUS_CHANGED_EVENT = 'CONVERSATION_STATUS_CHANGED';
